import { render } from "./MainLayout.vue?vue&type=template&id=13293337&ts=true"
import script from "./MainLayout.vue?vue&type=script&lang=ts"
export * from "./MainLayout.vue?vue&type=script&lang=ts"

import exportComponent from "/home/gitlab-deployer/builds/Bp7u02vYG/0/erp/sign/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__